import request from 'sb-request'
import actions from 'redux/actions'
import { reducers } from 'redux/core'


// TODO add replacement property to the pendingSubscriptionOrders when SB-2161 will be done - added 25/06/2020 by @mikediam
const fetchUndeliveredOrders = () =>
  request.post('graphql?name=pendingSubscriptionOrders', {
    body: {
      query: `{
        data: pendingSubscriptionOrders {
          isOrderInfoVisible
          hasEmptyProductsForNextMonth
          orders {
            year
            month
            shippingDate
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              image: img
              url
              name
              brand
              isSurprise
              upchargePrice
              isAddedAutomatically
              isFragranceOfTheMonth
            }
          }
        }
      }`,
    },
    modifyResult: ({ data = {} }) => {
      const { orders: rawOrders = [], ...rest } = data

      // Filter orders, because backend can send orders: [null]
      // TODO: remove after backend fix
      const orders = rawOrders.filter((item) => Boolean(item))

      return {
        ...rest,
        orders,
        isOrderInfoVisible: orders.length > 0,
      }
    },
  })
    .then(
      (data) => reducers.view.trackingPage.setShipment(data),
      () => {
        reducers.view.trackingPage.setFetched()
      }
    )

const fetchRecommendations = ({ gender }) => {
  reducers.view.trackingPage.setProductsFetching(true)

  actions.models.products.fetchRecommendations({ gender })
    .then(
      (products) => reducers.view.trackingPage.setProducts({ products, recommenderName: 'algoTagsNotes' }),
      () => reducers.view.trackingPage.setProductsFetching(false)
    )
}

const fetchPopularByGender = ({ gender, limit }) => {
  reducers.view.trackingPage.setProductsFetching(true)

  actions.models.products.fetchPopularByGender({ gender, limit })
    .then(
      (products) => {
        reducers.view.trackingPage.setProducts({ products, recommenderName: 'filterByTotalPurchases' })
      },
      () => {
        reducers.view.trackingPage.setProductsFetching(false)
      }
    )
}

export default {
  fetchUndeliveredOrders,
  fetchRecommendations,
  fetchPopularByGender,
}
